import { cn } from '@/lib/utils';

interface DetailRowProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
}

/**
 * Wiersz danych na kaflu: etykieta z lewej, wartość z prawej — ten sam rytm co wiersz rachunku,
 * żeby rozwinięty kafel czytało się jako jedną listę, a nie dwie różne tabelki.
 */
const DetailRow = ({
  label,
  children,
  className,
  ...props
}: DetailRowProps) => (
  <div
    className={cn('flex items-baseline gap-x-3 py-1.5 text-[15px]', className)}
    {...props}
  >
    {/* Łamie się wartość, nie etykieta: długi adres e-mail rozrywał „Adres e-mail" na dwie linie. */}
    <span className="shrink-0 text-neutral-600">{label}</span>
    <span className="wrap-anywhere ml-auto min-w-0 text-right font-medium text-ink">
      {children}
    </span>
  </div>
);

export default DetailRow;
